import { actionGenerator, IReduxAction } from '../../../actionGenerator';
import { ITopBets } from '../types';

export const LOAD_TOP_BETS_SUCCESS = 'TOP_BETS :: LOAD_TOP_BETS_SUCCESS';

export type TLoadTopBetsSuccessAction = IReduxAction<typeof LOAD_TOP_BETS_SUCCESS, ITopBets>;

export const loadTopBetsSuccess = actionGenerator<typeof LOAD_TOP_BETS_SUCCESS, ITopBets>(LOAD_TOP_BETS_SUCCESS);
